import { Injectable } from '@angular/core';
import { AbstractStateService } from '@tnq/shared/core';
import { calculationSchema, ICalculationState } from '../schemas';

@Injectable({
  providedIn: 'root',
})
export class CalculationStateService extends AbstractStateService<ICalculationState> {
  protected storageKey = 'tnq-cost-calculator';
  protected schema = calculationSchema;
}
